import React from "react";
import SbButton from "uiCore/SbButton/SbButton";
import { FileNameLink, DeleteIcon } from "./SbSbViewSourcesDrawerV2.styles";
import { COL_TITLE, COL_KEY, COL_WIDTH, FILE_STATUS } from "./SbSbViewSourcesDrawerV2.constants";
import { BUTTON_TYPE_TEXT } from "constants/ui.constants";

const buildColumns = (onFileClick, onDeleteClick, loading) => [
  {
    title: COL_TITLE.FILE_NAME,
    dataIndex: COL_KEY.FILE_NAME,
    render: (name, record) => (
      <FileNameLink onClick={() => onFileClick(record[COL_KEY.FILE_ID])}>
        {name}
      </FileNameLink>
    ),
  },
  {
    title: COL_TITLE.UPLOADED_BY,
    dataIndex: COL_KEY.UPLOADED_BY,
    width: COL_WIDTH.UPLOADED_BY,
  },
  {
    title: COL_TITLE.UPLOAD_DATE,
    dataIndex: COL_KEY.UPLOAD_DATE,
    width: COL_WIDTH.UPLOAD_DATE,
  },
  {
    title: COL_TITLE.FILE_SIZE,
    dataIndex: COL_KEY.FILE_SIZE,
    width: COL_WIDTH.FILE_SIZE,
  },
  {
    title: "",
    dataIndex: COL_KEY.FILE_ID,
    filterable: false,
    width: COL_WIDTH.ACTION,
    render: (fileId, record) =>
      record.file_status !== FILE_STATUS.SUBMITTED ? (
        <SbButton
          buttonType={BUTTON_TYPE_TEXT}
          icon={<DeleteIcon />}
          disabled={loading}
          onClick={(e) => {
            e.stopPropagation();
            onDeleteClick(fileId);
          }}
        />
      ) : null,
  },
];

export default buildColumns;
